import { AuthStatus } from '@caresend/types';
import { computed } from 'vue';
import { getStore } from '../../helpers/initStore.js';

const waitForStoreUserChange = async (
/**
 * If true, wait for the user to be present in the store and auth complete. If
 * false, wait for the user to be nullish in the store.
 */
waitForBound, timeout = 10000) => {
    const store = getStore();
    const userChangePromise = new Promise((resolve, reject) => {
        const isBound = computed(() => !!store.getters['auth/getUser']);
        const authComplete = computed(() => store.state.auth.authStatus === AuthStatus.COMPLETE);
        const getIsDoneWaiting = () => (waitForBound
            && isBound.value
            && authComplete.value) || (!waitForBound
            && !isBound.value);
        if (getIsDoneWaiting()) {
            resolve();
            return;
        }
        const unwatch = store.watch(() => isBound.value, () => {
            if (getIsDoneWaiting()) {
                unwatch();
                resolve();
            }
        });
        setTimeout(() => {
            unwatch();
            if (getIsDoneWaiting()) {
                resolve();
                return;
            }
            reject(Error(`Timeout waiting for user change to ${waitForBound ? 'bound' : 'unbound'}`));
        }, timeout);
    });
    await userChangePromise;
};
/**
 * Waits up to 10 seconds for the user to be nullish in the store. Throws an
 * error on timeout.
 */
const waitForUserUnbound = () => waitForStoreUserChange(false);
/**
 * Waits up to 10 seconds for the user to be present in the store, with
 * `authStatus: 'complete'`. Throws an error on timeout.
 */
const waitForUserBound = () => waitForStoreUserChange(true);

export { waitForUserBound, waitForUserUnbound };
